<h1 mat-dialog-title>{{data.title | translate}}</h1>
<div mat-dialog-content>
  <p [innerHtml]="data.message | translate"></p>
</div>
<div mat-dialog-actions>
  <button mat-flat-button [mat-dialog-close]="false">{{cancelButtonText | translate}}</button>
  <button mat-flat-button [color]="okButtonColor" [mat-dialog-close]="true">{{okButtonText | translate}}</button>
</div>